"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _queryString = require("query-string");

var _humps = require("humps");

// Adds a query string to the url if a 'query' option is provided
function addQueryToUrl(_ref) {
  var query = _ref.query,
      _ref$decamelizeQuery = _ref.decamelizeQuery,
      decamelizeQuery = _ref$decamelizeQuery === void 0 ? true : _ref$decamelizeQuery,
      url = _ref.url;
  if (!query) return;
  var transformedQuery = decamelizeQuery ? (0, _humps.decamelizeKeys)(query) : query;
  return {
    url: url + '?' + (0, _queryString.stringify)(transformedQuery)
  };
}

var _default = addQueryToUrl;
exports["default"] = _default;